<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
			<main class="lyear-layout-content">
				<div class="container-fluid">
					<div class="row">
						
						<div class="col-lg-12">
							<div class="card">
								<div class="card-body">
									
									<div class="edit-avatar">
										<img v-if="picture" :src="picture" alt="..." class="img-avatar">
										<img v-else src="../assets/images/noface.gif" alt="..." class="img-avatar">
										<div class="avatar-divider"></div>
										<!-- <div class="edit-avatar-content">
											<button class="btn btn-default">修改头像</button>
											<p class="m-0">选择一张你喜欢的图片，裁剪后会自动生成264x264大小，上传图片大小不能超过2M。</p>
										</div> -->
									</div>
									<hr>
									<!-- <form method="post" action="#!" class="site-form"> -->
										<div class="form-group">
											<label for="nickname">账号</label>
											<input type="text" class="form-control" name="nickname" id="nickname" placeholder="输入您的账号" disabled="disabled" v-model="account">
										</div>
										<div class="form-group">
											<label for="username">用户名</label>
											<input type="text" class="form-control" name="username" id="username" v-model="realName "  />
										</div>
										<div class="form-group">
											<label for="work">工作单位</label>
											<input type="text" class="form-control" name="wark" id="wark" placeholder="输入您的工作单位" v-model="department">
										</div>
										<div class="form-group">
											<label for="tel">联系电话</label>
											<input type="text" class="form-control" name="tel" id="tel" placeholder="输入您的联系电话" v-model="telephone">
										</div>
											 <div class="form-group">
											<label for="add">地址</label>
											<input type="text" class="form-control" name="add" id="add" placeholder="输入您的地址" v-model="address  ">
										</div>
										<div class="form-group" v-if="!email1">
											<label for="email1">邮箱</label>
											<input type="email" class="form-control" name="email" id="email1" aria-describedby="emailHelp" placeholder="请输入正确的邮箱地址" v-model="email ">
											<small id="emailHelp" class="form-text text-muted">请保证您填写的邮箱地址是正确的。</small>
										</div>
										<div class="form-group">
											<label for="remark">简介</label>
											<textarea class="form-control" name="remark" id="remark" rows="3" v-model="introduction "></textarea>
										</div>
										<div class="form-group">
											<div class="flex flex-x-s"><label for="remark">上传附件</label><a :href="`${$baseURL}/spc/zzrzxysm.doc`" class="shou ml-20 mb-5 bold download-a" >[下载委托授权书]</a></div>
											<div class="flex flex-x-s mt-8">
												<Upload
														ref="upload"
														:headers="{token:tokenStr}"
														:show-upload-list="false"
														:default-file-list="defaultList"
														:on-success="handleSuccess"
														:before-upload="handleBefore"
														accept="image/png,image/jpeg,image/tiff,application/pdf"
														:format="['png','jpeg','pdf','jpg']"
														:max-size="102400"
														type="select"
														name="file"
														:action="$baseURL + '/pub/api/package/uploadFile.do'">
														<div class="upload-btn shou t-c" style="width: 80px;">选择文件</div>
												</Upload>
												<div class="f-14 c-99 ml-10">{{attachRecords[0].name}}</div>
											</div>
										</div>
										
										<button @click="submitApply" class="btn btn-primary">提交</button>
									<!-- </form> -->
									<!-- http://localhost:8080/apinet -->
									<!-- http://www.tpahw.com-->
				 
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</main>
      <!--End 页面主要内容-->
    </div>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			picture: '',
			realName: '',
			account: '',
			department: '',
			telephone: '',
			address: '',
			introduction: '',
			email: '',
			email1:'',
			tokenStr: localStorage.getItem('token') || '',
			defaultList:[],
			attachRecords: [{
				fileId: 0,
				filePath: '',
				name: '',
				operator: localStorage.getItem('loginName'),
			}]
		}
  },
	
	components: {
		userLeft,
		userHead
	},

  created () {
	},
	
	mounted () {
		this.checkToken()
	},
	
  methods: {
		// 验证token的时效性
		async checkToken () {
			// 验证token的时效性
			let _this = this
			_this.$Spin.show()
			const tokenState = await this.util.checkToken(localStorage.getItem('token'))
			_this.picture = tokenState.data.picture || ''
			_this.realName = tokenState.data.username
			_this.account = tokenState.data.loginName
			_this.telephone = tokenState.data.mobileno
			_this.address = tokenState.data.address
			_this.email1 = tokenState.data.email
			_this.introduction = tokenState.data.introduction
			_this.$Spin.hide()
		},
		
		
		async submitApply () {
			let _this = this
			let data =  {
				account: _this.account,
				realName: _this.realName,
				department: _this.department,
				telephone: _this.telephone,
				address: _this.address,
				email: _this.email,
				introduction: _this.introduction,
				note: '',
				attachRecords: _this.attachRecords
			}
			
			if (data.realName == '') {
				return _this.$Message.warning('用户名不能为空')
			}
			if (data.department == '') {
				return _this.$Message.warning('工作单位不能为空')
			}
			
			if (!_this.util.isMobile(data.telephone)) {
				return _this.$Message.warning('请输入正确手机号')
			}
			if (data.address == '') {
				return _this.$Message.warning('地址不能为空')
			}
			if (!data.attachRecords[0].fileId) {
				return _this.$Message.warning('请先上传附件')
			}
			const res = await _this.post_res('/members/saveApplyRecord', data)
			if (res.code == 400) {
				_this.$Message.error({
					 content: res.message,
					 duration: 5
				})
			}
			if (res.status == 0) {
				 _this.$Message.success({
					 content: '提交成功，请等待审核',
					 duration: 5
				 })
				 setTimeout(()=>{
					 _this.$router.replace({path: '/userIndex'})
				 },3000)
			}
		},
		
		// 文件上传成功时的钩子
		async handleSuccess (response, file, fileList) {
			let _this = this
			this.attachRecords[0].fileId = response.fileRecordId
			this.attachRecords[0].filePath = response.url
				this.$Spin.hide()
		},
		
		handleBefore (e) {
				this.$Spin.show()
				// console.log(e)
				this.attachRecords[0].name = e.name
		},
	}
}
</script>

<style lang="less" scoped>
.download-a {
	color: #33cabb!important;
}
.upload-btn {
	background-color: #EFEFEF;
	font-size: 14px;
	color: #333;
	padding: 1px 8px;
	border-radius: 3px;
	border: 1px solid #aaa;
}
</style>
